// extracted by mini-css-extract-plugin
export var body = "_kk-0";
export var sectionHeader = "_kk-4";
export var shortcutColumns = "_kk-2";
export var shortcutList = "_kk-1";
export var shortcutSection = "_kk-3";